var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1.92 1.77c0-.71.49-.98 1.08-.6l11.27 7.15c.6.37.6.99 0 1.37L3 16.83c-.6.38-1.08.11-1.08-.6V1.78Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgPlay;